// @flow
import createAction from 'Store/utils/createAction';
import { TRIP_INFORMATION_SET_DURATION } from './duration.constants';

export function setDuration(value: ?number) {
  return createAction(TRIP_INFORMATION_SET_DURATION, { value });
}
